module.exports = __webpack_public_path__ + "media/images/icon/crown-2b7fb216c46d97baf62234c4348e2df0.svg";